// extracted by mini-css-extract-plugin
module.exports = {"title":"PaymentTitle_title__wo_Z5"};